module.exports = __webpack_public_path__ + "img/13.ca8d55a6.webp";